import React, { useEffect, useRef, useState } from 'react';
import {
	ButtonWrapper,
	Container,
	ContentWrapper,
	FilterWrapper,
	SingleFilterWrapper,
	SummaryValue,
	ValueWrapper,
} from './MultisourceSkuData.styles';
import MultiSelect from './components/MultiSelect';
import {
	generateAnalysisModule,
	getMultiSourceSkuFilterData,
	updateFilterModule,
} from 'utils/apiRequests';
import {
	ApButtonMain,
	ApButtonSecondary,
	ApInput,
	ApLoaderDefault,
	ApLoaderText,
} from '@alixpartners/ui-components';
import { filter, isNull } from 'lodash';
import TableView from './TableView';
import { SectionFormLabel } from 'Settings/FirstUsageSettings/styles';
import SKUModal from './components/SKUModal';
import ModuleNameModal from './components/ModuleNameModal';
import {
	useHistory,
	useLocation,
} from 'react-router-dom/cjs/react-router-dom.min';
import { Button } from 'components/SaveButton/styles';
import KpiList from './KpiList/KpiList';

export const filterInitialOptions = {
	category_1: {
		options: [],
		selectedOption: [],
	},
	category_2: {
		options: [],
		selectedOption: [],
	},
	category_3: {
		options: [],
		selectedOption: [],
	},
	commodity_Code: {
		options: [],
		selectedOption: [],
	},
	commodity_Family: {
		options: [],
		selectedOption: [],
	},
	origin_Country: {
		options: [],
		selectedOption: [],
	},
};
const payloadKeys = {
	category_1: 'category1',
	category_2: 'category2',
	category_3: 'category3',
	commodity_Code: 'commodityCode',
	commodity_Family: 'commodityFamily',
	origin_Country: 'originCountry',
};

export const filterSelectedOptions = options => {
	let filteredOptions = {};
	for (let key in options) {
		if (options[key].selectedOption && options[key].selectedOption.length > 0) {
			filteredOptions[key] = options[key];
		}
	}
	return filteredOptions;
};

export const transformFilterOptions = options => {
	let transformedOptions = {};
	for (let key in options) {
		if (options[key].selectedOption && options[key].selectedOption.length > 0) {
			transformedOptions[key] = {
				values: options[key].selectedOption,
				filterType: 'set',
			};
		}
	}
	return transformedOptions;
};

const MultisourceSkuData = () => {
	const [isFilterLoading, setIsFilterLoading] = useState(true);
	const [filterData, setFilterData] = useState(filterInitialOptions);
	const [close, onClose] = useState(false);
	const [columnDefs, setColumnDefs] = useState([]);
	const [isUpdating, setIsUpdating] = useState(false);
	const [name, setName] = useState(null);
	const [nameModal, setNameModal] = useState(false);
	const gridRef = useRef();
	const history = useHistory();
	const location = useLocation();
	const [disabledGenerateModule, setDisabledGenerateModule] = useState(false);
	const [counterToTriggerKPI, setCounterToTriggerKPI] = useState(1);
	const checkAndFormat = data => {
		return data.filter(x => x !== null).map(x => {
			return { label: x, value: x };
		});
	};
	useEffect(() => {
		return () => {
			history.replace({
				pathname: '/category-management/category-widgets',
				state: {},
			});
		};
	}, []);
	useEffect(() => {
		try {
			getMultiSourceSkuFilterData({}).then(response => {
				if (response.succeeded) {
					if (!isNull(response.data)) {
						if (Object.keys(response.data).length > 0) {
							const formatedCategory1Options = checkAndFormat(
								response.data.category1
							);
							const formatedCategory2Options = checkAndFormat(
								response.data.category2
							);
							const formatedCategory3Options = checkAndFormat(
								response.data.category3
							);
							const formatedCommodityCodeOptions = checkAndFormat(
								response.data.commodityCode
							);
							const formatedcommodityFamilyOptions = checkAndFormat(
								response.data.commodityFamily
							);
							const formatedoriginCountryOptions = checkAndFormat(
								response.data.originCountry
							);
							setFilterData(prevState => ({
								...prevState,

								category_1: {
									...prevState.category_1,
									options: formatedCategory1Options,
								},
								category_2: {
									...prevState.category_2,
									options: formatedCategory2Options,
								},
								category_3: {
									...prevState.category_3,
									options: formatedCategory3Options,
								},
								commodity_Code: {
									...prevState.commodity_Code,
									options: formatedCommodityCodeOptions,
								},
								commodity_Family: {
									...prevState.commodity_Family,
									options: formatedcommodityFamilyOptions,
								},
								origin_Country: {
									...prevState.origin_Country,
									options: formatedoriginCountryOptions,
								},
							}));
							setColumnDefs([
								{
									headerName: 'ID',
									field: 'iD',
									colId: 'ID',
									filter: 'agTextColumnFilter',
								},
								{
									headerName: 'Origin Country',
									field: 'origin_Country',
									colId: 'origin_Country',
									filterParams: {
										values: formatedoriginCountryOptions.map(x => x.value),
									},
									filter: 'agSetColumnFilter',
								},
								{
									headerName: 'Supplier',
									field: 'supplier',
									colId: 'Supplier',
									filter: 'agTextColumnFilter',
								},
								{
									headerName: 'SKU',
									field: 'sKU',
									colId: 'SKU',
									filter: 'agTextColumnFilter',
								},
								{
									headerName: 'Category 1',
									field: 'category_1',
									filterParams: {
										values: formatedCategory1Options.map(x => x.value),
									},
									colId: 'category_1',
									filter: 'agSetColumnFilter',
								},
								{
									headerName: 'Category 2',
									field: 'category_2',
									filterParams: {
										values: formatedCategory2Options.map(x => x.value),
									},
									colId: 'category_2',
									filter: 'agSetColumnFilter',
								},
								{
									headerName: 'Category 3',
									field: 'category_3',
									filterParams: {
										values: formatedCategory3Options.map(x => x.value),
									},
									colId: 'category_3',
									filter: 'agSetColumnFilter',
								},
								{
									headerName: 'Commodity Code',
									field: 'commodity_Code',
									filterParams: {
										values: formatedCommodityCodeOptions.map(x => x.value),
									},
									colId: 'commodity_Code',
									filter: 'agSetColumnFilter',
								},
								{
									headerName: 'Commodity Family',
									field: 'commodity_Family',
									filterParams: {
										values: formatedcommodityFamilyOptions.map(x => x.value),
									},
									colId: 'commodity_Family',
									filter: 'agSetColumnFilter',
								},
							]);
							setIsFilterLoading(false);
						}
					}
				}
			});
		} catch (error) {
			console.log(error);
			setIsFilterLoading(false);
		}
	}, []);
	useEffect(
		() => {
			if (location.state?.updateFilterData !== undefined) {
				// Parse the 'filters' field
				const filters = JSON.parse(location.state.updateFilterData.filters);

				// Extract all filter categories and their values
				for (const [key, value] of Object.entries(filters)) {
					setFilterData(prevState => ({
						...prevState,
						[key]: {
							...prevState[key],
							selectedOption: value.values,
						},
					}));
				}
				onClose(true);
				setIsUpdating(true);
			}
		},
		[location.state?.updateFilterData]
	);
	const onFilterChangeHandler = (key, value) => {
		setFilterData(prevState => ({
			...prevState,
			[key]: {
				...prevState[key],
				selectedOption: value,
			},
		}));
		const newFilters = {
			category1: filterData.category_1.selectedOption,
			category2: filterData.category_2.selectedOption,
			category3: filterData.category_3.selectedOption,
			commodityCode: filterData.commodity_Code.selectedOption,
			commodityFamily: filterData.commodity_Family.selectedOption,
			originCountry: filterData.origin_Country.selectedOption,
			[payloadKeys[key]]: value,
		};

		getMultiSourceSkuFilterData(newFilters).then(response => {
			if (response.succeeded) {
				if (!isNull(response.data)) {
					if (Object.keys(response.data).length > 0) {
						const formatedCategory1Options = checkAndFormat(
							response.data.category1
						);
						const formatedCategory2Options = checkAndFormat(
							response.data.category2
						);
						const formatedCategory3Options = checkAndFormat(
							response.data.category3
						);
						const formatedCommodityCodeOptions = checkAndFormat(
							response.data.commodityCode
						);
						const formatedcommodityFamilyOptions = checkAndFormat(
							response.data.commodityFamily
						);
						const formatedoriginCountryOptions = checkAndFormat(
							response.data.originCountry
						);
						setFilterData(prevState => ({
							...prevState,

							category_1: {
								...prevState.category_1,
								options: formatedCategory1Options,
							},
							category_2: {
								...prevState.category_2,
								options: formatedCategory2Options,
							},
							category_3: {
								...prevState.category_3,
								options: formatedCategory3Options,
							},
							commodity_Code: {
								...prevState.commodity_Code,
								options: formatedCommodityCodeOptions,
							},
							commodity_Family: {
								...prevState.commodity_Family,
								options: formatedcommodityFamilyOptions,
							},
							origin_Country: {
								...prevState.origin_Country,
								options: formatedoriginCountryOptions,
							},
						}));
						setColumnDefs([
							{
								headerName: 'ID',
								field: 'iD',
								colId: 'ID',
								filter: 'agTextColumnFilter',
							},
							{
								headerName: 'Origin Country',
								field: 'origin_Country',
								colId: 'origin_Country',
								filterParams: {
									values: formatedoriginCountryOptions.map(x => x.value),
								},
								filter: 'agSetColumnFilter',
							},
							{
								headerName: 'Supplier',
								field: 'supplier',
								colId: 'Supplier',
								filter: 'agTextColumnFilter',
							},
							{
								headerName: 'SKU',
								field: 'sKU',
								colId: 'SKU',
								filter: 'agTextColumnFilter',
							},
							{
								headerName: 'Category 1',
								field: 'category_1',
								filterParams: {
									values: formatedCategory1Options.map(x => x.value),
								},
								colId: 'category_1',
								filter: 'agSetColumnFilter',
							},
							{
								headerName: 'Category 2',
								field: 'category_2',
								filterParams: {
									values: formatedCategory2Options.map(x => x.value),
								},
								colId: 'category_2',
								filter: 'agSetColumnFilter',
							},
							{
								headerName: 'Category 3',
								field: 'category_3',
								filterParams: {
									values: formatedCategory3Options.map(x => x.value),
								},
								colId: 'category_3',
								filter: 'agSetColumnFilter',
							},
							{
								headerName: 'Commodity Code',
								field: 'commodity_Code',
								filterParams: {
									values: formatedCommodityCodeOptions.map(x => x.value),
								},
								colId: 'commodity_Code',
								filter: 'agSetColumnFilter',
							},
							{
								headerName: 'Commodity Family',
								field: 'commodity_Family',
								filterParams: {
									values: formatedcommodityFamilyOptions.map(x => x.value),
								},
								colId: 'commodity_Family',
								filter: 'agSetColumnFilter',
							},
						]);
						setIsFilterLoading(false);
					}
				}
			}
		});
	};
	const onFilterApplyHandler = () => {
		const filtersApplied = filterSelectedOptions(filterData);
		const filterModelData = transformFilterOptions(filtersApplied);
		gridRef.current.api.setFilterModel(filterModelData);
		gridRef.current.api.onFilterChanged();
		onClose(false);
		setCounterToTriggerKPI(counterToTriggerKPI + 1);
	};
	const onGenerateModule = async () => {
		setDisabledGenerateModule(state => !state);
		const filtersApplied = filterSelectedOptions(filterData);
		const filterModelData = transformFilterOptions(filtersApplied);
		await generateAnalysisModule({
			uI_Name: name,
			filterjson: JSON.stringify(filterModelData),
		});
		history.push({
			pathname: '/category-management/category-widgets',
			search: '?isSegment=true', // query string
			state: {
				// location state
				isSegment: true,
			},
		});
		setNameModal(false);
		setName(null);
		setDisabledGenerateModule(state => !state);
	};
	const handleModuleUpdate = async () => {
		const stalefilters = location.state?.updateFilterData;
		const filtersApplied = filterSelectedOptions(filterData);
		const filterModelData = transformFilterOptions(filtersApplied);
		const updatedFilters = {
			...stalefilters,
			ui_name: stalefilters.name,
			filterjson: JSON.stringify(filterModelData),
		};
		await updateFilterModule(updatedFilters);
		onClose(false);
	};
	const handleModuleCreate = () => {
		onClose(false);
		setNameModal(state => !state);
	};
	const resetFilter = () => {
		setFilterData(filterInitialOptions);
		const newFilters = {
			category1: filterInitialOptions.category_1.selectedOption,
			category2: filterInitialOptions.category_2.selectedOption,
			category3: filterInitialOptions.category_3.selectedOption,
			commodityCode: filterInitialOptions.commodity_Code.selectedOption,
			commodityFamily: filterInitialOptions.commodity_Family.selectedOption,
			originCountry: filterInitialOptions.origin_Country.selectedOption,
		};
		getMultiSourceSkuFilterData(newFilters).then(response => {
			if (response.succeeded) {
				if (!isNull(response.data)) {
					if (Object.keys(response.data).length > 0) {
						const formatedCategory1Options = checkAndFormat(
							response.data.category1
						);
						const formatedCategory2Options = checkAndFormat(
							response.data.category2
						);
						const formatedCategory3Options = checkAndFormat(
							response.data.category3
						);
						const formatedCommodityCodeOptions = checkAndFormat(
							response.data.commodityCode
						);
						const formatedcommodityFamilyOptions = checkAndFormat(
							response.data.commodityFamily
						);
						const formatedoriginCountryOptions = checkAndFormat(
							response.data.originCountry
						);
						setFilterData(prevState => ({
							...prevState,

							category_1: {
								...prevState.category_1,
								options: formatedCategory1Options,
							},
							category_2: {
								...prevState.category_2,
								options: formatedCategory2Options,
							},
							category_3: {
								...prevState.category_3,
								options: formatedCategory3Options,
							},
							commodity_Code: {
								...prevState.commodity_Code,
								options: formatedCommodityCodeOptions,
							},
							commodity_Family: {
								...prevState.commodity_Family,
								options: formatedcommodityFamilyOptions,
							},
							origin_Country: {
								...prevState.origin_Country,
								options: formatedoriginCountryOptions,
							},
						}));
						setColumnDefs([
							{
								headerName: 'ID',
								field: 'iD',
								colId: 'ID',
								filter: 'agTextColumnFilter',
							},
							{
								headerName: 'Origin Country',
								field: 'origin_Country',
								colId: 'origin_Country',
								filterParams: {
									values: formatedoriginCountryOptions.map(x => x.value),
								},
								filter: 'agSetColumnFilter',
							},
							{
								headerName: 'Supplier',
								field: 'supplier',
								colId: 'Supplier',
								filter: 'agTextColumnFilter',
							},
							{
								headerName: 'SKU',
								field: 'sKU',
								colId: 'SKU',
								filter: 'agTextColumnFilter',
							},
							{
								headerName: 'Category 1',
								field: 'category_1',
								filterParams: {
									values: formatedCategory1Options.map(x => x.value),
								},
								colId: 'category_1',
								filter: 'agSetColumnFilter',
							},
							{
								headerName: 'Category 2',
								field: 'category_2',
								filterParams: {
									values: formatedCategory2Options.map(x => x.value),
								},
								colId: 'category_2',
								filter: 'agSetColumnFilter',
							},
							{
								headerName: 'Category 3',
								field: 'category_3',
								filterParams: {
									values: formatedCategory3Options.map(x => x.value),
								},
								colId: 'category_3',
								filter: 'agSetColumnFilter',
							},
							{
								headerName: 'Commodity Code',
								field: 'commodity_Code',
								filterParams: {
									values: formatedCommodityCodeOptions.map(x => x.value),
								},
								colId: 'commodity_Code',
								filter: 'agSetColumnFilter',
							},
							{
								headerName: 'Commodity Family',
								field: 'commodity_Family',
								filterParams: {
									values: formatedcommodityFamilyOptions.map(x => x.value),
								},
								colId: 'commodity_Family',
								filter: 'agSetColumnFilter',
							},
						]);
						setIsFilterLoading(false);
					}
				}
			}
		});
		onFilterApplyHandler();
	};
	return (
		<ContentWrapper>
			{isFilterLoading ? (
				<div style={{ marginTop: '200px' }}>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</div>
			) : (
				<>
					<Container>
						<KpiList
							filterData={filterData}
							counterToTriggerKPI={counterToTriggerKPI}
						/>
					</Container>
					{close && (
						<SKUModal
							title={`SKU Analysis and Filtering ${
								isUpdating
									? `Update for ` + location.state.updateFilterData.name
									: ''
							}`}
							onClose={onClose}
						>
							<FilterWrapper>
								<SingleFilterWrapper>
									<SectionFormLabel>Select</SectionFormLabel>
									<MultiSelect
										name="category_1"
										label="Category 1"
										options={filterData.category_1.options}
										selected={filterData.category_1.selectedOption}
										disabled={false}
										isLoading={false}
										onChange={v => {
											onFilterChangeHandler('category_1', v);
										}}
									/>
								</SingleFilterWrapper>

								<SingleFilterWrapper>
									<SectionFormLabel>Select</SectionFormLabel>
									<MultiSelect
										name="category_2"
										label="Category 2"
										options={filterData.category_2.options}
										selected={filterData.category_2.selectedOption}
										disabled={false}
										isLoading={false}
										onChange={v => {
											onFilterChangeHandler('category_2', v);
										}}
									/>
								</SingleFilterWrapper>

								<SingleFilterWrapper>
									<SectionFormLabel>Select</SectionFormLabel>
									<MultiSelect
										name="category_3"
										label="Category 3"
										options={filterData.category_3.options}
										selected={filterData.category_3.selectedOption}
										disabled={false}
										isLoading={false}
										onChange={v => {
											onFilterChangeHandler('category_3', v);
										}}
									/>
								</SingleFilterWrapper>

								<SingleFilterWrapper>
									<SectionFormLabel>Select</SectionFormLabel>
									<MultiSelect
										name="commodity_code"
										label="Commodity Code"
										options={filterData.commodity_Code.options}
										selected={filterData.commodity_Code.selectedOption}
										disabled={false}
										isLoading={false}
										onChange={v => {
											onFilterChangeHandler('commodity_Code', v);
										}}
									/>
								</SingleFilterWrapper>

								<SingleFilterWrapper>
									<SectionFormLabel>Select</SectionFormLabel>
									<MultiSelect
										name="commodity_family"
										label="Commodity Family"
										options={filterData.commodity_Family.options}
										selected={filterData.commodity_Family.selectedOption}
										disabled={false}
										isLoading={false}
										onChange={v => {
											onFilterChangeHandler('commodity_Family', v);
										}}
									/>
								</SingleFilterWrapper>
								<SingleFilterWrapper>
									<SectionFormLabel>Select</SectionFormLabel>
									<MultiSelect
										name="origin_Country"
										label="Origin Country"
										options={filterData.origin_Country.options}
										selected={filterData.origin_Country.selectedOption}
										disabled={false}
										isLoading={false}
										onChange={v => {
											onFilterChangeHandler('origin_Country', v);
										}}
									/>
								</SingleFilterWrapper>
								<div>
									<ButtonWrapper>
										<ApButtonSecondary onClick={onFilterApplyHandler}>
											Apply Filters
										</ApButtonSecondary>
										<br />
										<ApButtonMain
											onClick={() => {
												isUpdating
													? handleModuleUpdate()
													: handleModuleCreate();
											}}
										>
											{isUpdating
												? 'Update Analysis Module'
												: 'Generate Analysis Module'}
										</ApButtonMain>
									</ButtonWrapper>
								</div>
							</FilterWrapper>
						</SKUModal>
					)}
					{nameModal && (
						<ModuleNameModal title={'Module Name Change'} onClose={onClose}>
							<div
								style={{
									display: 'flex',
									justifyContent: 'space-between',
									margin: '30px',
								}}
							>
								<SummaryValue>
									<ValueWrapper>
										<ApInput
											type="text"
											onChange={v => {
												setName(v);
											}}
										/>
									</ValueWrapper>
								</SummaryValue>
								<Button
									type="submit"
									disabled={disabledGenerateModule}
									onClick={() => onGenerateModule()}
								>
									Save
								</Button>
							</div>
						</ModuleNameModal>
					)}
					<span
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							marginBottom: '10px',
							marginTop: '5px',
						}}
					>
						<span />
						<span>
							<ApButtonSecondary
								iconName="filter_outlined"
								onClick={() => onClose(state => !state)}
								style={{ marginRight: '5px' }}
							>
								Select Filter
							</ApButtonSecondary>

							<ApButtonSecondary
								iconName="filter_outlined"
								onClick={() => resetFilter()}
							>
								Reset Filter
							</ApButtonSecondary>
						</span>
					</span>
					{columnDefs.length !== 0 && (
						<TableView gridRef={gridRef} columnDefs={columnDefs} />
					)}
				</>
			)}
		</ContentWrapper>
	);
};

export default MultisourceSkuData;
